import template from 'lodash.template';
import appConfig from 'src/utils/appConfig';
import registrationStore from 'src/stores/registrationStore';
import { getLocaleData } from 'src/utils/localeMapping';
import FlowNode from './flowNode';
import { getReturnToURLFromParams } from '../router/queryString';
import { getRawQueryString } from 'src/router/queryString';
import { pricesURL } from '@lessonnine/babbel-urls.js';
import environmentMapping from 'src/utils/environmentMapping';
import { addAuthTokenToURL } from 'src/libs/autoLoginService';
import { mergeUrlParams } from 'src/utils/url';

const getURLVariables = () => {
  const { locale, environment } = appConfig.getMyConfig();
  const learningLanguage = appConfig.getLearningLanguage();
  const redirectNodeConfig = environmentMapping[environment] || environmentMapping.test;
  const { displayLanguage, localeCountryCode } = getLocaleData(locale);

  return Object.assign({
    locale,
    displayLanguage,
    localeCountryCode,
    learningLanguage
  }, redirectNodeConfig);
};

const getReturnToURLFromTemplate = (urlTemplateString) => {
  const urlVariables = getURLVariables();
  const  url = template(urlTemplateString)(urlVariables);

  return mergeUrlParams(url, getRawQueryString());
};

const getReturnToURLFromConfig = (config) => {
  if (config.url) {
    const urlTemplateString = config.url[appConfig.getDeviceType()];
    return getReturnToURLFromTemplate(urlTemplateString);
  }
  return pricesURL(appConfig.getLearningLanguage());
};

export default class RedirectNode extends FlowNode {
  constructor(id, data) {
    super(id, data);
    this.data = data;
  }

  // We always need to go via the accounts app, passing the auth_token, to log the user in
  // You can skip authentication by passing `skipAuth: true` in the redirect node config
  // Returns the return_to url from the query params *if present*, otherwise the url declared in the redirectNode config
  getURL() {
    const { signin_token: signInToken } = registrationStore.getUserData();
    const { accountsLoginUrl } = appConfig.getMyConfig();

    const returnToURL = getReturnToURLFromParams() || getReturnToURLFromConfig(this.data);

    if (this.data.skipAuth === true) {
      return returnToURL;
    }

    const loginUrlWithReturnTo = `${accountsLoginUrl}?return_to=${encodeURIComponent(returnToURL)}`;
    return addAuthTokenToURL(loginUrlWithReturnTo, signInToken);
  }
}

